import axios from '@/core/axios';

import { Photo, RmaElement } from './rma-element.types';

export class RmaElementsService {
  list(device_id: number): Promise<RmaElement[]> {
    if (!device_id) throw new Error('Missing device id in list rma');
    return axios.post<RmaElement[]>(`/rma-element/list`, { device_id }).then(resp => resp?.data);
  }

  generate(device_id: number, force: boolean): Promise<void> {
    if (!device_id) throw new Error('Missing device id in generate rma');
    return axios.post<void>(`/rma-element/generate`, { device_id, force }).then(resp => resp?.data);
  }

  deleteGrading(device_id: number): Promise<void> {
    if (!device_id) throw new Error('Missing device id in deleteGrading rma');
    return axios.post<void>(`/rma-element/delete-grading`, { device_id }).then(resp => resp?.data);
  }

  deletefailure(device_id: number, device_failure_id: number): Promise<void> {
    if (!device_id) throw new Error('Missing device id in deletefailure rma');
    return axios.post<void>(`/rma-element/delete-failure`, { device_id, device_failure_id }).then(resp => resp?.data);
  }

  selected(rma_element_id: number): Promise<void> {
    if (!rma_element_id) throw new Error('Missing rma_element_id in selected');
    return axios.post<void>(`/rma-element/${rma_element_id}/selected`).then(resp => resp?.data);
  }

  create(device_id: number, step: string, desc): Promise<RmaElement[]> {
    if (!device_id) throw new Error('Missing device id in create rma');
    return axios.post<RmaElement[]>(`/rma-element/create`, { device_id, step, desc }).then(resp => resp?.data);
  }

  add(rma_element: RmaElement): Promise<RmaElement[]> {
    return axios.post<RmaElement[]>(`/rma-element/add`, { rma_element }).then(resp => resp?.data);
  }

  update(rma_element: RmaElement): Promise<RmaElement[]> {
    return axios.post<RmaElement[]>(`/rma-element/${rma_element.id}/update`, { rma_element }).then(resp => resp?.data);
  }

  delete(rma_element_id: number): Promise<RmaElement[]> {
    if (!rma_element_id) throw new Error('Missing rma_element_id in delete');
    return axios.delete<RmaElement[]>(`/rma-element/${rma_element_id}/delete`).then(resp => resp?.data);
  }

  async addPhoto(rma_element_id: number, photo: Record<string, File>): Promise<RmaElement> {
    if (!rma_element_id) throw new Error('Missing rma_element_id in addPhoto');

    const formData = Object.entries(photo).reduce((prev, curr) => {
      prev.append(`rma_element[${curr[0]}]`, curr[1]);
      return prev;
    }, new FormData());

    const resp = await axios.put<RmaElement>(`rma-element/${rma_element_id}/add-photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return resp?.data;
  }

  deletePhotos(rma_element_id: number, photos: (string | File | Photo)[]): Promise<void> {
    if (!rma_element_id) throw new Error('Missing rma_element_id in deletePhoto');
    return axios.post<void>(`/rma-element/${rma_element_id}/delete-photos`, { photos }).then(resp => resp?.data);
  }
}

export const rmaElementsService = new RmaElementsService();
